import { useState } from "react";
import { api, apiError } from "../lib/api";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-panel">
        <div className="brand">Loan<span>Control</span></div>
        <div className="subtitle">Partner finance operations</div>
        <p className="login-note">PAN INDIA OPERATIONS · Fictional demonstration · No bank connections</p>
      </div>
      <div className="login-main">
        <form className="card login-card" onSubmit={submit} data-testid="login-form">
          <span className="pill warn">SIMULATION ONLY</span>
          <h1 style={{ marginTop: 14 }}>Sign in</h1>
          <p className="muted">Accounts are created by your administrator. There is no public sign-up.</p>
          <label>Email
            <input type="email" autoComplete="username" required value={email}
              onChange={e => setEmail(e.target.value)} data-testid="login-email-input" />
          </label>
          <label style={{ marginTop: 14 }}>Password
            <input type="password" autoComplete="current-password" required value={password}
              onChange={e => setPassword(e.target.value)} data-testid="login-password-input" />
          </label>
          {error && <div className="notice warning space" role="alert" data-testid="login-error">{error}</div>}
          <button type="submit" className="primary login-btn" disabled={busy} data-testid="login-submit-btn">
            {busy ? "Signing in…" : "Sign in"}
          </button>
          <p className="muted" style={{ fontSize: 12, marginBottom: 0 }}>
            Forgot your password? Ask your administrator to reset it.
          </p>
        </form>
      </div>
    </div>
  );
}
